import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';

@Injectable({
  providedIn: 'root'
})
export class InternalCustomInternalServiceClaimReturnService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +
    'internal-custom-internal-service-claim-returns';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX +
    'internal-custom-internal-service-claim-returns';
    this.httpClient = http;
  }

  public printPdf(guid: string, templateDocId: string, printServiceClassName: string, apiVisa: ApiVisa): Observable<Blob> {
    let params = new HttpParams()
          .set('templateDocId', templateDocId)
          .set('printServiceClassName', printServiceClassName);

    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
     );
  }
}
